import { z } from 'zod';
import { BranchCodeSchema } from './requests.js';

export const PurchaseItemSchema = z.object({
  sku: z.string().min(1),
  qty: z.number().int().positive(),
  unit_cost: z.number().nonnegative().optional(),
});
export type PurchaseItemInput = z.infer<typeof PurchaseItemSchema>;

export const CreatePurchaseOrderSchema = z.object({
  supplier_id: z.number().int().positive(),
  dest_branch: BranchCodeSchema.default('bp'),
  items: z.array(PurchaseItemSchema).min(1),
  eta_date_promised: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  note: z.string().max(1000).optional(),
  // If true, bypass the double-order warning (user confirmed)
  force: z.boolean().optional().default(false),
  // Mark as 'ordered' immediately (supplier has been contacted outside system)
  mark_ordered: z.boolean().optional().default(true),
});
export type CreatePurchaseOrderInput = z.infer<typeof CreatePurchaseOrderSchema>;

export const ReceivePurchaseOrderSchema = z.object({
  // Per-line receipts; missing lines keep existing qty_received unchanged
  lines: z.array(
    z.object({
      sku: z.string().min(1),
      qty_received: z.number().int().nonnegative(),
    })
  ).min(1),
  // If all lines are fully received, status transitions to 'received'
  // (otherwise stays 'ordered' until a later call completes it)
  note: z.string().max(500).optional(),
});
export type ReceivePurchaseOrderInput = z.infer<typeof ReceivePurchaseOrderSchema>;

export const MarkStuckSchema = z.object({
  reason: z.string().max(500).optional(),
});
export type MarkStuckInput = z.infer<typeof MarkStuckSchema>;

export const CancelPurchaseOrderSchema = z.object({
  reason: z.string().max(500),
});
export type CancelPurchaseOrderInput = z.infer<typeof CancelPurchaseOrderSchema>;
